import { LocationsServiceInterface } from 'domain/services/locations';
import {
  GetAddressViaZipCodeUseCaseInterface,
  GetAllCitiesForSelectOptionsUseCaseInterface,
} from 'domain/usecases';

export class LocationsService implements LocationsServiceInterface {
  constructor(
    private readonly _getAllCitiesForSelectOptionsUseCase: GetAllCitiesForSelectOptionsUseCaseInterface,
    private readonly _getAddressViaZipCodeUseCase: GetAddressViaZipCodeUseCaseInterface,
  ) {}

  async getAllCitiesForSelectOptions(
    params: GetAllCitiesForSelectOptionsUseCaseInterface.Params,
  ): Promise<GetAllCitiesForSelectOptionsUseCaseInterface.Result> {
    return await this._getAllCitiesForSelectOptionsUseCase.execute(params);
  }

  async getAddressViaZipCode(
    params: GetAddressViaZipCodeUseCaseInterface.Params,
  ): Promise<GetAddressViaZipCodeUseCaseInterface.Result> {
    return await this._getAddressViaZipCodeUseCase.execute(params);
  }
}
